var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.026,
    height: 45.01,
    viewBox: "0 0 36.026 45.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-clube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag",
    transform: "translate(-48.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4734",
    "data-name": "Path 4734",
    d: "M84.817,38.907,82.24,9.886a1.24,1.24,0,0,0-1.233-1.132H75.7a8.893,8.893,0,0,0-17.783,0h-5.3a1.234,1.234,0,0,0-1.233,1.132L48.809,38.907c0,.037-.009.074-.009.11,0,3.3,3.028,5.992,6.756,5.992H78.07c3.728,0,6.756-2.688,6.756-5.992A.448.448,0,0,0,84.817,38.907Zm-18-36.422A6.413,6.413,0,0,1,73.22,8.753H60.407A6.413,6.413,0,0,1,66.813,2.485ZM78.07,42.525H55.556c-2.338,0-4.234-1.546-4.271-3.452l2.467-27.825h4.16v3.774a1.243,1.243,0,0,0,2.485,0V11.248H73.22v3.774a1.243,1.243,0,0,0,2.485,0V11.248h4.16l2.476,27.825C82.3,40.978,80.4,42.525,78.07,42.525Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClube);
export default __webpack_public_path__ + "static/media/ic_clube.c89f18f0ecb735f570c23e7aa8babffd.svg";
export { ForwardRef as ReactComponent };